var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Box from "../box/Box";
import Img from "../image/Image";
var PageHeader = function (_a) {
    var bgImageSrc = _a.bgImageSrc, contentImageProps = _a.contentImageProps;
    return (React.createElement(Box, { display: "grid", className: "oui-page-header" },
        React.createElement(Box, { gridColumn: "1 / -1", gridRow: 1, zIndex: 1 },
            React.createElement(Img, { lazyLoad: false, src: bgImageSrc, alt: "", "aria-hidden": true })),
        contentImageProps && (React.createElement(Box, { gridColumn: "1 / -1", gridRow: 1, zIndex: 2, display: "flex", justifyContent: "center", py: [6, 6, 6, 8], px: 8, maxWidth: ["360px", "360px", "360px", "540px"], mx: "auto" },
            React.createElement(Img, __assign({}, contentImageProps))))));
};
export default PageHeader;
//# sourceMappingURL=PageHeader.js.map